import { useState } from 'react';

export const useEdit = (form) => {
  const [isEditable, setEdit] = useState(false);

  /**
   * @name edit
   * @description 편집 상태 활성화
   *
   * @returns void
   * */
  const edit = () => {
    setEdit(true);
  };

  /**
   * @name edit
   * @description 편집 상태 비활성화
   *
   * @returns void
   * */
  const closeEdit = () => {
    setEdit(false);
  };

  /**
   * @name cancelEdit
   * @description 편집 상태 비활성화 및 초기화
   *
   * @returns void
   * */
  const cancelEdit = () => {
    setEdit(false);
    form.resetFields();
  };

  return { isEditable, edit, closeEdit, cancelEdit };
};
